/**
 * OtherRadioPanel — Other Radios panel.
 *
 * Renders the `otherRadios` store slice with three grouped subcategories:
 *   1. Management              → 92 (M-1), 93 (O-1), 98 (L-1)
 *   2. Engineering / Security Center → 105 (E-2), 113 (E-3), 47 (E-4), 50 (E-5), 116 (E-6), 108 (SC-82), 118 (SC-81)
 *   3. Available / Spare       → 10, 28, 51, 52, R-23  (+ any user-added radios)
 *
 * The three security-supervisor radios (95 / 97 / 99) are filtered out here
 * because they are now displayed in SupRadioPanel. The underlying store
 * still holds them — SupRadioPanel writes back to the otherRadios slice.
 */
import { useDesktopStore } from '../../stores/desktop'
import type { RadioSlot } from '../../stores/desktop'
import RadioSection from './RadioSection'

const SECURITY_SUP_IDS = ['95', '97', '99']

const OTHER_RADIO_GROUPS = [
  { label: 'Management',                     ids: ['92', '93', '98']                          },
  { label: 'Engineering / Security Center',  ids: ['105', '113', '47', '50', '116', '108', '118'] },
  { label: 'Available / Spare',              ids: ['10', '28', '51', '52', 'R-23']             },
]

export default function OtherRadioPanel() {
  const { otherRadios, setOtherRadios } = useDesktopStore()

  // Hide security-supervisor radios (displayed in SupRadioPanel instead)
  const displayed = otherRadios.filter(r => !SECURITY_SUP_IDS.includes(r.id))

  // When RadioSection writes back, re-attach the hidden security-sup radios
  // so we don't accidentally drop them from the store.
  function handleSet(next: RadioSlot[]) {
    setOtherRadios([
      ...otherRadios.filter(r => SECURITY_SUP_IDS.includes(r.id)),
      ...next,
    ])
  }

  return (
    <RadioSection
      radios={displayed}
      setRadios={handleSet}
      title="Other Radios"
      naType="Other Radio"
      groups={OTHER_RADIO_GROUPS}
      spareGroupLabel="Available / Spare"
    />
  )
}
